import React, { Component } from 'react';
import { MdRowActionIcon } from './mdPageIcons';
import './ConfirmDialog.css';

export class ConfirmDialog extends Component {
  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      document.body.style.overflow = 'hidden';
    } else if (prevProps.open && !this.props.open) {
      document.body.style.overflow = '';
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
  }

  handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && !this.props.loading) {
      this.props.onCancel();
    }
  };

  render() {
    const {
      open,
      title,
      message,
      detail,
      confirmLabel = 'Confirmar',
      cancelLabel = 'Cancelar',
      variant = 'danger',
      loading = false,
      confirmIcon,
      onConfirm,
      onCancel,
    } = this.props;

    if (!open) {
      return null;
    }

    return (
      <div
        className="confirm-dialog__backdrop"
        onClick={this.handleBackdropClick}
        role="presentation"
      >
        <div
          className="confirm-dialog"
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="confirm-dialog-title"
          aria-describedby="confirm-dialog-message"
        >
          <h2 id="confirm-dialog-title" className="confirm-dialog__title">
            {title}
          </h2>
          <p id="confirm-dialog-message" className="confirm-dialog__message">
            {message}
          </p>
          {detail ? <p className="confirm-dialog__detail">{detail}</p> : null}
          <div className="confirm-dialog__actions">
            <button
              type="button"
              className="confirm-dialog__btn confirm-dialog__btn--secondary"
              onClick={onCancel}
              disabled={loading}
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              className={'confirm-dialog__btn confirm-dialog__btn--' + variant}
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? (
                'Procesando...'
              ) : (
                <>
                  {confirmIcon ? <MdRowActionIcon name={confirmIcon} /> : null}
                  {confirmLabel}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
